webpackJsonp([214916770094388],{

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Organization = function (_Component) {
	  _inherits(Organization, _Component);
	
	  function Organization() {
	    _classCallCheck(this, Organization);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Organization.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'insid-header activity-header', style: { marginTop: '100px' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'insid-header-text activity-header-text' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'wow fadeIn', 'data-wow-duration': '.2s', 'data-wow-delay': '.1s' },
	                  'Organizzazione e processi aziendali'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'activity about2' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-lg-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'activity-text wow fadeIn animated', 'data-wow-duration': '.5s', 'data-wow-delay': '.2s' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'activity-h2' },
	                  'Dettagli'
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Revisione dei modelli organizzativi in essere e sviluppo di nuove modalit\xE0 organizzative.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Analisi dei ruoli e delle mansioni.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Revisione dei processi aziendali in logica lean per il miglioramento dell\u2019efficienza.'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Organization;
	}(_react.Component);
	
	exports.default = Organization;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-organization-it-js-c0633d065548c5591fe3.js